import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-white px-4 py-6 sm:px-6" data-id="element-91" data-mp="3gf96f0gd6eb2">
      <div className="mx-auto max-w-3xl text-center" data-id="element-92" data-mp="3ggk72reij5xy">
        <p className="font-display text-2xl uppercase leading-none text-charcoal sm:text-3xl" data-id="element-93" data-mp="32oe11y52qfc8">
          Padel Coach Pro™
        </p>
        <p className="mt-1 text-[13px] leading-snug text-softgray" data-id="element-94" data-mp="36pzb7bq84fiq">
          The complete ready-to-coach system for professional padel coaches. Because professional
          coaching should not require rebuilding every session from scratch.
        </p>

        <p className="mt-2 flex items-center justify-center gap-1.5 text-xs text-softgray sm:text-[13px]" data-id="element-95" data-mp="3lelyq0q08dl1">
          <MailIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-96" data-mp="3qcx8yck7oq3s" />
          Support:{' '}
          <a href="mailto:kitonline27@gmail.com" className="underline hover:text-brand" data-id="element-97" data-mp="29ynjtg85axbw">
            kitonline27@gmail.com
          </a>
        </p>

        <p className="mt-3 text-[11px] text-softgray" data-id="element-98" data-mp="2ezl0fodibjba">© 2026 Kit Online — All Rights Reserved.</p>
        <p className="mx-auto mt-1.5 max-w-2xl text-[11px] leading-snug text-softgray" data-id="element-99" data-mp="3l9sin4pzgsoh">
          The resources provided are intended for professional educational and coaching purposes.
          Coaches remain responsible for adapting all materials to their qualifications, players,
          training objectives, and coaching environment.
        </p>
        <p className="mt-1.5 text-[11px] text-softgray" data-id="element-100" data-mp="828ni7pom7a7">
          Terms &amp; Conditions · Privacy Policy · Contact
        </p>
      </div>
    </footer>;
}